import { Spacing } from '@persona-id/design-tokens';
import styled, { css } from 'styled-components';

import { StyleValueJustify } from 'lib/inquiryStyles';

const Container = styled.div<CenteredPictographProps>`
  display: flex;

  justify-content: ${({ justify }) => justify};
  position: relative;

  ${({ marginTop, marginBottom, marginLeft, marginRight }) => css`
    margin-top: ${marginTop};
    margin-bottom: ${marginBottom ?? Spacing[5]};
    margin-left: ${marginLeft};
    margin-right: ${marginRight};
  `}

  /* Don't take space if there's no child pictograph */
  :empty {
    margin-bottom: 0;
  }

  svg {
    ${({ height }) => height != null && `height: ${height}px;`}
    ${({ width }) => width != null && `width: ${width}px;`}
  }
`;

interface CenteredPictographProps {
  height?: number;
  width?: number;
  justify?: StyleValueJustify;
  children: JSX.Element;
  title?: string;
  /**
   * Required for a11y. Only explicitly pass undefined if `role` is set to
   * something else.
   */
  'aria-label': string | null;
  role?: string;
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
}

const CenteredPictograph = ({
  height = 100,
  width = 100,
  justify = StyleValueJustify.Center,
  children,
  title,
  'aria-label': ariaLabel,
  role = 'img',
  ...centeredPictographMargins
}: CenteredPictographProps) => {
  return (
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    <Container
      height={height}
      width={width}
      justify={justify}
      title={title}
      aria-label={ariaLabel}
      role={role}
      {...centeredPictographMargins}
    >
      {children}
    </Container>
  );
};

export default CenteredPictograph;
